const formatIban = (value: string): string =>
  value
    .replace(/[^\dA-Z]/gi, '')
    .toUpperCase()
    .replace(/(.{4})/g, '$1 ')
    .trim()

export default formatIban
